import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { EntraIdSelectedMapping } from 'src/app/tenant/models/entra-id-mapping.model';
import {
  DeleteEntraIdDepartmentMapping,
  DeleteEntraIdJobPositionMapping,
  DeleteEntraIdShiftMapping,
} from 'src/app/tenant/state/entra-id-mapping.actions';
import { Store } from '@ngxs/store';
import { TenantTableNames } from '../../../../../tenant/enums/tenant-table-names';

@Component({
  selector: 'app-tenant-templates',
  templateUrl: './tenant-templates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TenantTemplatesComponent {
  @Input() specificTemplateName: string;
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };
  @Input() hideButtons: boolean;
  @HostBinding('class.action-button-column') get isActionButton() {
    return this.columnName === 'actionButton';
  }

  tenantTableNames = TenantTableNames;

  constructor(private store: Store) {}

  deleteMapping(mapping: EntraIdSelectedMapping & { tenantId: string }): void {
    const isDepartment = !!mapping.department;
    const isJobPosition = !!mapping.position;
    const isShift = !!mapping.shift;
    if (isDepartment) {
      this.store.dispatch(new DeleteEntraIdDepartmentMapping(mapping.tenantId, mapping.id));
    }
    if (isJobPosition) {
      this.store.dispatch(new DeleteEntraIdJobPositionMapping(mapping.tenantId, mapping.id));
    }
    if (isShift) {
      this.store.dispatch(new DeleteEntraIdShiftMapping(mapping.tenantId, mapping.id));
    }
  }
}
